import { useMutation, useQuery } from '@tanstack/react-query';
import { getShipping, shippingORC, updateStateShipping } from '../api/shipping';

export const useGetShipping = ({ enabled = true, ...params }) => {
  return useQuery({
    queryKey: ['shippingList', params, enabled],
    queryFn: ({ signal }) => getShipping(params, signal),
    enabled,
  });
};

export const useShippingORC = () => {
  return useMutation({
    mutationFn: ({ dto, signal }) => shippingORC(dto, signal),
  });
};

export const useUpdateStateShipping = () => {
  return useMutation({
    mutationFn: ({ params, dto, signal }) => updateStateShipping(params, dto, signal),
  });
};
